import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import { FaClipboardList, FaStethoscope, FaFileInvoiceDollar, FaCertificate } from "react-icons/fa";
import classes from "./HorizontalNav.module.css";

const HorizontalNav = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const billingRoutes = [
    "/dashboard/billing",
    "/dashboard/billing/billreports",
    "/dashboard/billing/billingconfig",
    "/dashboard/billing/newbill",
    "/dashboard/billing/datewisebilling",
    "/dashboard/billing/chargemaster",
  ];

  const isBilling = billingRoutes.includes(location.pathname);

  const getActiveClassName = ({ isActive }) =>
    isActive ? `${classes.link} ${classes.active}` : classes.link;

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className={classes.container}>
      <nav className={classes.navbar}>
        {/* 🔹 Hamburger (mobile) */}
        <button className={classes.hamburger} onClick={toggleMenu}>
          <i className="fa fa-bars"></i>
        </button>

        {/* 🔹 Menu */}
        {isBilling ? (
          <ul className={`${classes.menu} ${menuOpen ? classes.show : ""}`}>
            <li>
              <NavLink to="billreports" className={getActiveClassName} onClick={closeMenu}>
                <FaFileInvoiceDollar /> {t("Billing Statements")}
              </NavLink>
            </li>
            <li>
              <NavLink to="newbill" className={getActiveClassName} onClick={closeMenu}>
                <FaClipboardList /> {t("New Bill")}
              </NavLink>
            </li>
            <li>
              <NavLink to="billingconfig" className={getActiveClassName} onClick={closeMenu}>
                <FaFileInvoiceDollar /> {t("Billing History")}
              </NavLink>
            </li>
            <li>
              <NavLink to="datewisebilling" className={getActiveClassName} onClick={closeMenu}>
                <FaFileInvoiceDollar /> {t("Datewise Billing")}
              </NavLink>
            </li>
            <li>
              <NavLink to="chargemaster" className={getActiveClassName} onClick={closeMenu}>
                <FaFileInvoiceDollar /> {t("Charge Sheet")}
              </NavLink>
            </li>
          </ul>
        ) : (
          <ul className={`${classes.menu} ${menuOpen ? classes.show : ""}`}>
            <li>
              <NavLink
                to="./waitingl"
                className={({ isActive }) =>
                  (isActive || location.pathname === "/dashboard/reports")
                    ? `${classes.link} ${classes.active}`
                    : classes.link
                }
                onClick={closeMenu}
              >
                <FaClipboardList /> {t("Waiting List Report")}
              </NavLink>
            </li>
            <li>
              <NavLink to="./checkupl" className={getActiveClassName} onClick={closeMenu}>
                <FaStethoscope /> {t("CheckUp Report")}
              </NavLink>
            </li>
            <li>
              <NavLink to="./billreports" className={getActiveClassName} onClick={closeMenu}>
                <FaFileInvoiceDollar /> {t("Billing Statements")}
              </NavLink>
            </li>
            <li>
              <NavLink to="./certificatereports" className={getActiveClassName} onClick={closeMenu}>
                <FaCertificate /> {t("Certificate Report")}
              </NavLink>
            </li>
            <li>
              <NavLink to="datewisebilling" className={getActiveClassName} onClick={closeMenu}>
                <FaFileInvoiceDollar /> {t("Datewise Billing")}
              </NavLink>
            </li>
          </ul>
        )}
      </nav>
    </div >
  );
};

export default HorizontalNav;
